import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-role-type-modal',
  templateUrl: './role-type-modal.component.html',
  styleUrls: ['./role-type-modal.component.css']
})
export class RoleTypeModalComponent implements OnInit, OnDestroy {

  @ViewChild("values", { static: false }) valueRef: ElementRef | undefined;

  @Input() roleTypeData: any;
  @Input() roleTypeAdd: any;
  @Input() roleTypeView: any;
  @Input() roleTypeEdit: any;

  roleTypeForm: FormGroup;
  loading: boolean = false;
  formSubmitted: boolean = false;
  color: ThemePalette = 'primary';
  errorMessage: any = null;
  
  private _afterClosedSubscription: Subscription;
  private _saveRoleTypeSubscription: Subscription;
  
  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog
  ) {
    this.roleTypeForm = this._fb.group({
      roletype: ['', [Validators.required,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      color: ['', [Validators.required]],
      colorDesc: ['', [Validators.required,Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });
  }

  ngOnInit(): void {
    this._loadModalData();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe(); 
    this._saveRoleTypeSubscription?.unsubscribe(); 
    
  }
  closeModal() {
    if (this.roleTypeForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: {msg:Messages.UNSAVED_CHANGES,type:null},
        disableClose: true
      });
      this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
        if(result){
          this._activeModal.close();
        }
      });
    }
    else {
      this._activeModal.close();
    }
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.roleTypeForm.invalid) {
      return;
    }
    this._saveRoleType();
  }
  get formValues() {
    return this.roleTypeForm.controls;
  }

  private _loadModalData() {
    if (this.roleTypeData) {
      if (this.roleTypeView) {
        this.roleTypeForm.disable();
      }
    }
    this._patchValues();
  }

  private _patchValues() {
    if (this.roleTypeAdd) {
      this.roleTypeForm.patchValue({ roletype: this.roleTypeForm.value.roletype, color: this.roleTypeForm.value.color, colorDesc: this.roleTypeForm.value.colorDesc });
    } else {
      this.roleTypeForm.patchValue({
        roletype: this.roleTypeData.roletype, color: this.roleTypeData.color, colorDesc: this.roleTypeData.colorDesc
      });
    }
  }
  private _saveRoleType() {
    this.errorMessage = null;
    if (this.roleTypeForm.invalid) {
      return;
    }

    // this.loading = true;
    let colorData;
    // if (this.roleTypeAdd) {
    //   this.roleTypeForm.value.color = '#'+ this.roleTypeForm.value.color.hex;
    //   colorData = { set: this.roleTypeForm.value };
    // } else {
    //   if(!this.roleTypeForm.controls['roletype'].dirty) {
    //     this.roleTypeForm.value.description = null;
    //     this.roleTypeForm.controls['roletype'].clearValidators();
    //   }
    //   if(!this.roleTypeForm.controls['color'].dirty) {
    //     this.roleTypeForm.value.roleName = null;
    //     this.roleTypeForm.controls['color'].clearValidators();
    //   }else {
    //     this.roleTypeForm.value.color = '#'+ this.roleTypeForm.value.color.hex;
    //   }
    //   if(!this.roleTypeForm.controls['colorDesc'].dirty) {
    //     this.roleTypeForm.value.roleName = null;
    //     this.roleTypeForm.controls['colorDesc'].clearValidators();
    //   }
    colorData = this.roleTypeData?{ roleTypeId:this.roleTypeData._id,set: this.roleTypeForm.value }:{ set: this.roleTypeForm.value };
    // }
    this._saveRoleTypeSubscription = this._service.saveRoleType(colorData).subscribe((result: any) => {
      if (result["status"] && result["response"]) {
        if (result["status"]) {
          this._service.toasterService({ type: 'success', msg: result['response']['message'] });
          this.loading = false;
          this._activeModal.close(true);
        } else {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this.loading = false;
        }
      } else {
        if (result["response"]) {
          this.errorMessage = result['response']['message'] + ' - ' + result['response']['error'];
          // this._service.toasterService({ type: 'error', msg: result['response']['message'] });
          this.loading = false;
        }
      }
    });
  }
  
}
